import { pushEvent } from 'src/client/data-layer';
import { LayoutMode } from 'src/components/layout-buttons/types';

export const trackProductCollectionLayoutChangeClick = (
  fromLayout: LayoutMode,
  toLayout: LayoutMode
) => {
  const fromAndToLayout = `${fromLayout} -> ${toLayout}`;
  pushEvent('ProductCollectionLayoutChangeClick', {
    fromAndToLayout,
  });
};
